// TODO: combine with ApplicationOutcomeType to avoid duplication
// https://breathelife.atlassian.net/browse/HOT-2657
export enum UnderwritingDataReportCategory {
  Prescription = 'prescription',
  MVR = 'mvr',
  IdentityCheck = 'identityCheck',
  MIB = 'mib',
  MedicalHistory = 'medicalHistory',
}
